/* Выделяет найденные совпадения тексте желтоватым маркером */
export const formatFoundText = (text: string, foundWord?: string): string => {
  if (
    foundWord &&
    !text?.includes('<mark style="background-color: #fdf2c6">')
  ) {
    //была ошибка в Sentry
    const arr: string[] = text.split('');
    const listIdx: number[] = [];
    let lastIdx: number = -1;

    while (
      (lastIdx = text
        .toLowerCase()
        .indexOf(foundWord.toLowerCase(), lastIdx + 1)) !== -1
    ) {
      listIdx.push(lastIdx);
    }

    listIdx.forEach((item, index) => {
      //TODO: попытаться передавать id в mark для якорной связки
      arr.splice(
        item + index * 2,
        0,
        '<mark style="background-color: #fdf2c6">'
      );
      arr.splice(item + index * 2 + 1 + foundWord.length, 0, '</mark>');
    });

    return arr.join('');
  }

  return text;
};

/* удаление Emojis */
export const replaceEmojis = (str: string) => {
  return str.replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
    ''
  );
};

/* Преобразует имена в результатах транскрибации (SPEAKER_00 -> Абонент 1); SPEAKER_XX и превращается в Абонент N, где N = XX + 1 */
export const transformNames = (text: string): string => {
  return text.replace(
    /SPEAKER_(\d{2})\b/g,
    (_match: string, speakerNumber: string) =>
      `Абонент ${Number(speakerNumber) + 1}`
  );
};

/* Преобразует первую букву в заглавную, игнорируя не буквенные символы (например, ", -, +, etc.) даже если они идут раньше первой буквы */
export const firstLetterToUpperCase = (value: string): string => {
  return value.replace(/^[^a-zа-яё]*([a-zа-яё])/i, function (m: string) {
    return m.toUpperCase();
  });
};

/*
  Склонение существительных в зависимости от числа
  Пример использования: integerDeclination(5, ['год', 'года', 'лет'])
  Результат: "лет"
*/
export const integerDeclination = (number: number, titles: string[]) => {
  const cases = [2, 0, 1, 1, 1, 2];

  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
};

export const makeInitialsFromStrName = (name: string) => {
  const array = name.split(' ');

  try {
    return `${array[0]} ${array[1] ? array[1][0] + '.' : ''} ${
      array[2] ? array[2][0] + '.' : ''
    }`;
  } catch (e) {
    console.log(e);

    return name;
  }
};

/**
 * Обрезает строку до заданной максимальной длины, оставляя
 * определенное количество символов в начале и в конце,
 * а также добавляет троеточие в середину для обозначения
 * сокращения текста.
 *
 * @param str - Исходная строка, которую нужно обрезать.
 * @param maxLength - Максимальная длина строки после обрезки.
 *                    Если исходная строка меньше или равна этой длине,
 *                    она будет возвращена без изменений.
 * @param frontChars - (необязательный) Количество символов, которые
 *                     должны оставаться в начале строки. По умолчанию 10.
 * @param backChars - (необязательный) Количество символов, которые
 *                    должны оставаться в конце строки. По умолчанию 10.
 *
 * @returns - Обрезанная строка в формате "Начало...Конец".
 *
 * Пример:
 * truncateString("Очень длинное имя файла, которое нужно обрезать", 30)
 * вернет "Очень длинное имя...обрезать".
 *
 * truncateString("Файл с очень длинным именем", 30, 5, 5)
 * вернет "Файл с...именем".
 */
export const truncateString = (
  str: string,
  maxLength: number,
  frontChars: number = 10,
  backChars: number = 10
): string => {
  if (str.length <= maxLength) {
    return str;
  }

  return (
    str.substring(0, frontChars) + '...' + str.substring(str.length - backChars)
  );
};

/**
 * Форматирует число, добавляя разделители между тысячами.
 *
 * @param num - Число, которое нужно отформатировать.
 * @param separator - Разделитель, используемый для разделения разрядов (по умолчанию: пробел).
 * @returns Отформатированная строка с разделителями.
 */
export const formatNumber = (
  num: number | string,
  separator: string = ' '
): string => {
  return (+num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

/**
 * Преобразует полное ФИО в сокращённый формат "Фамилия И.О.".
 *
 * @param fullName - Полное ФИО (например, "Иванов Иван Иванович")
 * @returns Сокращённое ФИО (например, "Иванов И.И.")
 */
export const formatShortName = (fullName: string): string => {
  const parts = fullName.trim().split(/\s+/);

  if (parts.length < 2) {
    return fullName;
  }

  const lastName = parts[0];
  const initials = parts
    .slice(1)
    .map((name) => name.charAt(0).toUpperCase() + '.')
    .join('');

  return `${lastName} ${initials}`;
};

/** Удаление HTML-тегов из строки */
export const removeHtmlTags = (html: string): string => {
  if (!html) {
    return '';
  }

  return html
    .replace(/<[^>]*>/g, '') // Удаляем все HTML-теги
    .replace(/&nbsp;/g, ' ') // Заменяем неразрывные пробелы
    .replace(/&amp;/g, '&') // Заменяем HTML-сущности
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .trim();
};

/* Преобразует ФИО в два инициала для "иконки" юзера "Иванов Иван Иванович" -> "ИИ" */
export const makeInitialsAvatar = (fullName: string) => {
  return fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w: string) => w.substring(0, 1).toUpperCase())
    .join('');
};

/* Преобразует данные пользователя (фамилия, имя, отчество) в строку ФИО в формате "Фамилия Имя Отчество" */
export const getFullName = (item: {
  last_name: string;
  first_name?: string;
  patronymic_name: string | null;
  short_name?: string;
}): string => {
  return `${item?.last_name} ${item?.first_name} ${
    item?.patronymic_name ? ` ${item.patronymic_name}` : ''
  } `.trim();
};

/** Форматирует адрес дома */
export const formatHouseAddress = (address: string): string => {
  return address
    .replace('г ', 'г. ')
    .replace('п ', 'п. ')
    .replace('ул ', 'ул. ')
    .replace('обл ', 'обл. ')
    .replace(', ', ',')
    .split(',')
    .join(', ');
};

export const getPlainText = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  return doc.body.textContent ?? '';
};

/** Преобразует обычные кавычки (") в кавычки-ёлочки («»); каждая пара кавычек заменяется своей парой «» */
export const toGuillemets = (text: string): string => {
  return text.replace(/"([^"]*)"/g, '«$1»');
};
